export const ESHOP_TYPE_B2B = 1;
export const ESHOP_TYPE_B2C = 2;
export const ESHOP_TYPE_B2B_LOCKED = 3;
export const ESHOP_TYPE_MIXED = 4;

export const ATTACHMENT_TYPE_FILE = 1;
export const ATTACHMENT_TYPE_URL = 2;
export const ATTACHMENT_EXTENSION_PDF = "pdf";

export const ADDITIONAL_INFOS_TYPE_SIZES_TABLE = 1;
export const ADDITIONAL_INFOS_TYPE_PERSON = 2;
export const ADDITIONAL_INFOS_STORE_MANAGER_HASH = "store_manager";

export const GRID_ROWS = "rows";
export const GRID_COLS = "cols";

export const HOOK_TYPE_HARD = 1;
export const HOOK_TYPE_SOFT = 2;
export const HOOK_TYPE_DISCOUNT = 3;

export const CATEGORY_PARAMETERS_BASIC = 1;
export const CATEGORY_PARAMETERS_ADVANCED = 2;
export const CATEGORY_PARAMETERS_SHOW_LIMIT = 5;

export const SHOPPING_LIST_PRIVATE = 1;
export const SHOPPING_LIST_PUBLIC = 2;
